import { render, staticRenderFns } from "./PurchaseOrderBase.vue?vue&type=template&id=11594d90&"
import script from "./PurchaseOrderBase.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports